<!--We transitioned from one version of the view to another, so much more IF logic was controlling this.  We can probably
simply this to remove a component / view-->
<app-home data-cy="landing-home-component"></app-home>
